/* Razvan Garage – reguli de coș pentru produsele Conex.
   1. Garanția de piesă la schimb: produsele care au metafield-ul custom.garantie_schimb_varianta primesc în coș,
      automat, varianta de garanție (produsul „garantie-piesa-la-schimb”), în aceeași cantitate. Garanția fără
      piesa ei este scoasă din coș.
   2. Vânzarea la set: produsele cu metafield-ul custom.multiplu_vanzare (ex. 2) stau în coș numai în multipli. */
(() => {
  if (window.rgGarantieSchimb) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const json = {'Content-Type': 'application/json', Accept: 'application/json'};
  let running = false;
  let again = false;

  // Aduce garanțiile din coș la cantitatea pieselor care le cer. Întoarce true dacă a schimbat coșul.
  async function sync() {
    if (running) { again = true; return false; }
    running = true;
    let changed = false;
    try {
      const res = await fetch(root + '?sections=rg-garantie-cos', {credentials: 'same-origin'});
      if (!res.ok) return false;
      const html = (await res.json())['rg-garantie-cos'] || '';
      const match = html.match(/<script[^>]*data-rg-gs-cart[^>]*>([\s\S]*?)<\/script>/);
      if (!match) return false;
      const lines = JSON.parse(match[1]);
      const cut = [];
      // down = true: cantitatea rotunjită în sus nu a fost primită de coș, se rotunjește în jos.
      const plan = (down) => {
        const need = {};
        const have = {};
        const updates = {};
        cut.length = 0;
        for (const line of lines) {
          if (line.is_dep) { have[line.variant] = (have[line.variant] || 0) + line.qty; continue; }
          let qty = line.qty;
          // Produsele vândute la set: cantitatea e mereu multiplu de „mult” și nu trece de seturile întregi din stoc
          // (cart/update.js primește și cantități peste stoc, deci limita se pune aici).
          if (line.mult > 1) {
            let target = (down ? Math.floor(qty / line.mult) : Math.ceil(qty / line.mult)) * line.mult;
            if (typeof line.max === 'number') {
              target = Math.min(target, Math.floor(Math.max(line.max, 0) / line.mult) * line.mult);
            }
            if (target !== qty) {
              if (target < qty) cut.push({title: line.title, mult: line.mult, stock: line.max, left: target});
              qty = target;
              updates[line.variant] = qty;
            }
          }
          if (line.dep) need[line.dep] = (need[line.dep] || 0) + qty;
        }
        for (const id of new Set([...Object.keys(need), ...Object.keys(have)])) {
          if ((need[id] || 0) !== (have[id] || 0)) updates[id] = need[id] || 0;
        }
        return updates;
      };
      const send = (updates) => fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({updates})
      });
      let updates = plan(false);
      if (!Object.keys(updates).length) return false;
      let up = await send(updates);
      if (!up.ok) {
        updates = plan(true);
        if (Object.keys(updates).length) up = await send(updates);
      }
      changed = up.ok;
      if (changed) {
        refreshCart();
        cut.filter((c) => typeof c.stock === 'number').forEach((c) => notify(
          `„${c.title}” se vinde doar la set de ${c.mult} bucăți. În stoc ${c.stock === 1 ? 'este o singură bucată' : `sunt ${c.stock} bucăți`}, `
          + (c.left ? `așa că în coș au rămas ${c.left}.` : 'așa că nu poate fi comandat acum.')
        ));
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
    } finally {
      running = false;
      if (again) { again = false; sync(); }
    }
    return changed;
  }

  function refreshCart() {
    const drawer = document.querySelector('cart-drawer');
    const items = document.querySelector('cart-items');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh(true);
    else if (items && typeof items.refresh === 'function') items.refresh();
    fetch(root + '?sections=cart-icon-bubble', {credentials: 'same-origin'})
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data && data['cart-icon-bubble']) bubble.innerHTML = data['cart-icon-bubble'];
      })
      .catch(() => {});
  }

  // Mesaj scurt pentru client, sus pe ecran (dispare singur sau la clic).
  function notify(text) {
    const box = document.createElement('div');
    box.setAttribute('role', 'status');
    box.textContent = text;
    box.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:2147483000;width:max-content;max-width:min(92vw,520px);'
      + 'padding:12px 16px;border:1px solid #e6d98a;border-left:6px solid #f2c200;border-radius:10px;background:#fffbe0;color:#23272f;'
      + 'font-size:14px;line-height:1.45;box-shadow:0 6px 24px rgba(0,0,0,.18);cursor:pointer;';
    box.addEventListener('click', () => box.remove());
    document.body.appendChild(box);
    setTimeout(() => box.remove(), 9000);
  }

  // Produsele vândute la set, pe pagina produsului: cantitatea nu trece de seturile întregi din stoc,
  // iar un set incomplet (ex. o singură bucată rămasă) nu poate fi pus în coș.
  function setLimit(scope) {
    const note = scope && scope.querySelector('[data-rg-set][data-rg-set-max]');
    return note ? parseInt(note.dataset.rgSetMax, 10) : null;
  }

  function applySetLimits() {
    document.querySelectorAll('[data-rg-set][data-rg-set-max]').forEach((note) => {
      const scope = note.closest('.product-info') || note.closest('.shopify-section');
      const max = setLimit(scope);
      if (!scope || max === null || Number.isNaN(max)) return;
      const input = scope.querySelector('.js-product-form input[name="quantity"], quantity-input input[name="quantity"]');
      const button = scope.querySelector('.js-product-form [name="add"]');
      if (max > 0 && input) input.max = String(max);
      if (max === 0 && button && !button.disabled) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  // Pe pagina produsului: garanția intră în coș înaintea piesei, ca sertarul coșului să le arate pe amândouă.
  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.js-product-form')) return;
    if (form.dataset.rgGsDone === '1') { delete form.dataset.rgGsDone; return; }
    const scope = form.closest('.product-info') || form.closest('.shopify-section');
    const max = setLimit(scope);
    if (max === 0) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }
    const field = form.querySelector('input[name="quantity"]') || (scope && scope.querySelector('quantity-input input[name="quantity"]'));
    if (max > 0 && field && parseInt(field.value, 10) > max) field.value = String(max);
    const note = scope && scope.querySelector('[data-rg-gs]');
    if (!note || !note.dataset.variantId) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    try {
      const quantity = Math.max(1, parseInt(new FormData(form).get('quantity') || '1', 10) || 1);
      await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: json,
        body: JSON.stringify({items: [{id: Number(note.dataset.variantId), quantity}]})
      });
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
    form.dataset.rgGsDone = '1';
    if (typeof form.requestSubmit === 'function') form.requestSubmit(evt.submitter || undefined);
    else form.submit();
  }, true);

  // Plasă de siguranță: după orice schimbare a coșului și la încărcarea paginii.
  const later = () => setTimeout(sync, 900);
  document.addEventListener('on:cart:add', later);
  document.addEventListener('on:line-item:change', later);
  document.addEventListener('on:cart:error', later);
  const start = () => { applySetLimits(); sync(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Fereastra cu condițiile de returnare a piesei vechi.
  document.addEventListener('click', (evt) => {
    const open = evt.target.closest('[data-rg-gs-open]');
    if (open) {
      const dialog = document.querySelector('[data-rg-gs-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const dialog = evt.target.closest('[data-rg-gs-dialog]');
    if (dialog && (evt.target.closest('[data-rg-gs-close]') || evt.target === dialog)) dialog.close();
  });

  window.rgGarantieSchimb = {sync};
})();
